export default __webpack_public_path__ + "static/media/question.b60df122.svg";